import { render } from "./cable.vue?vue&type=template&id=828f8dde&scoped=true"
import script from "./cable.vue?vue&type=script&lang=js"
export * from "./cable.vue?vue&type=script&lang=js"

import "./cable.vue?vue&type=style&index=0&id=828f8dde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828f8dde"]])

export default __exports__